import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalender = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip-path-calendar",
		children: /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_13076",
			"data-name": "Rectangle 13076",
			width: 33.607,
			height: 34.322,
			fill: "#d9daee"
		})
	}) }), /* @__PURE__ */ _jsxs("g", {
		id: "Group_14550",
		"data-name": "Group 14550",
		transform: "translate(-1780.752 -143.314)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Group_12083",
			"data-name": "Group 12083",
			transform: "translate(1780.752 143.314)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39267",
				"data-name": "Path 39267",
				d: "M30,0A30,30,0,1,1,0,30,30,30,0,0,1,30,0Z",
				fill: "#fff",
				opacity: .655
			})
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group_12215",
			"data-name": "Group 12215",
			transform: "translate(1760.334 -246)",
			children: [/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_13077",
				"data-name": "Rectangle 13077",
				width: 27.17,
				height: 21.45,
				transform: "translate(36.43 408.29)",
				fill: "#d9daee"
			}), /* @__PURE__ */ _jsxs("g", {
				id: "Group_4649",
				"data-name": "Group 4649",
				transform: "translate(35 404)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_8194",
						"data-name": "Path 8194",
						d: "M22.22,13.225V2.5H16.5",
						transform: "translate(7.095 1.075)",
						fill: "#d9daee",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_4644",
						"data-name": "Group 4644",
						transform: "translate(0.715 0.715)",
						children: /* @__PURE__ */ _jsxs("g", {
							id: "Group_4650",
							"data-name": "Group 4650",
							children: [
								/* @__PURE__ */ _jsx("path", {
									id: "Path_8195",
									"data-name": "Path 8195",
									d: "M6.22,2.5H.5V25.38H16.23",
									transform: "translate(-0.5 0.36)",
									fill: "#d9daee",
									stroke: "#7284fa",
									strokeLinecap: "round",
									strokeLinejoin: "round",
									strokeWidth: 1
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_13072",
									"data-name": "Rectangle 13072",
									width: 4.29,
									height: 5.72,
									transform: "translate(5.72)",
									fill: "#d9daee",
									stroke: "#7284fa",
									strokeLinecap: "round",
									strokeLinejoin: "round",
									strokeWidth: 1
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_13073",
									"data-name": "Rectangle 13073",
									width: 4.29,
									height: 5.72,
									transform: "translate(18.59)",
									fill: "#d9daee",
									stroke: "#7284fa",
									strokeLinecap: "round",
									strokeLinejoin: "round",
									strokeWidth: 1
								})
							]
						})
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_490",
						"data-name": "Line 490",
						x2: 8.58,
						transform: "translate(10.725 3.575)",
						fill: "none",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_4646",
						"data-name": "Group 4646",
						transform: "translate(0.715 10.725)",
						children: /* @__PURE__ */ _jsxs("g", {
							id: "Group_4651",
							"data-name": "Group 4651",
							children: [/* @__PURE__ */ _jsx("line", {
								id: "Line_491",
								"data-name": "Line 491",
								x2: 28.6,
								fill: "none",
								stroke: "#7284fa",
								strokeLinecap: "round",
								strokeLinejoin: "round",
								strokeWidth: 1
							}), /* @__PURE__ */ _jsx("path", {
								id: "Path_8196",
								"data-name": "Path 8196",
								d: "M17,26.8l-5,1.43,1.43-5L24.158,12.5l3.575,3.575Z",
								transform: "translate(4.445 -5.35)",
								fill: "#d9daee",
								stroke: "#7284fa",
								strokeLinecap: "round",
								strokeLinejoin: "round",
								strokeWidth: 1
							})]
						})
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_492",
						"data-name": "Line 492",
						x2: 3.575,
						y2: 3.575,
						transform: "translate(26.458 20.735)",
						fill: "none",
						stroke: "#7284fa",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_4648",
						"data-name": "Group 4648",
						transform: "translate(0 0)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_4647",
							"data-name": "Group 4647",
							clipPath: "url(#clip-path-calendar)",
							children: /* @__PURE__ */ _jsx("line", {
								id: "Line_493",
								"data-name": "Line 493",
								x2: 3.575,
								y2: 3.575,
								transform: "translate(18.59 28.602)",
								fill: "none",
								stroke: "#7284fa",
								strokeLinecap: "round",
								strokeLinejoin: "round",
								strokeWidth: 1
							})
						})
					})
				]
			})]
		})]
	})]
});
export default SvgCalender;
